module.exports = __webpack_public_path__ + "img/userico.0cda8f69.svg";